import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { SubTitle } from "common/components/Title/SubTitle";
import { CommissionSettings } from "./CommissionSettings";
import { AutoFinishSettings } from "./AutoFinishSettings";
import { StaleOrdersSettings } from "./StaleOrdersSettings";

export const SettingsPage: FC = () => {
  return (
    <>
      <div className="flex w-full justify-between">
        <SubTitle>Настройки</SubTitle>
      </div>
      <div className="px-[5px]">
        <Routes>
          <Route path="/commission" element={<CommissionSettings />} />
          <Route path="/auto-finish" element={<AutoFinishSettings />} />
          <Route path="/stale-cancel" element={<StaleOrdersSettings />} />
          <Route path="/*" element={<Navigate to="/settings/commission" />} />
        </Routes>
      </div>
    </>
  );
};
